<template>
  <AppSlidingPanel v-model="isOpen" container-class="changelog-panel">
    <div class="changelog-panel__inner">
      <header class="changelog-panel__header">
        <h2 class="changelog-panel__title">
          <i class="fa-solid fa-bullhorn" />
          Changelog
        </h2>
        <button
          type="button"
          class="changelog-panel__close"
          aria-label="Close changelog"
          @click="store.close()">
          <i class="fa-solid fa-xmark" />
        </button>
      </header>

      <div class="changelog-panel__body">
        <template v-if="store.entries.length">
          <ChangelogEntryCard
            v-for="entry in store.entries"
            :key="entry.id"
            :entry="entry" />
          <button
            v-if="store.hasMore"
            type="button"
            class="changelog-panel__load-more"
            :disabled="store.loading"
            @click="store.loadMore()">
            <i v-if="store.loading" class="fa-solid fa-spinner fa-spin" />
            Load more
          </button>
        </template>

        <div v-else-if="store.loading" class="changelog-panel__skeleton">
          <div
            v-for="i in 3"
            :key="i"
            class="changelog-panel__skeleton-card" />
        </div>

        <div v-else-if="store.loadFailed" class="changelog-panel__empty">
          <i class="fa-solid fa-triangle-exclamation" />
          <p>Couldn't load updates.</p>
          <button
            type="button"
            class="changelog-panel__retry"
            @click="store.loadMore()">
            Try again
          </button>
        </div>

        <div v-else class="changelog-panel__empty">
          <i class="fa-solid fa-bullhorn" />
          <p>No updates yet — check back soon.</p>
        </div>
      </div>
    </div>
  </AppSlidingPanel>
</template>

<script setup>
import { computed } from 'vue'
import { AppSlidingPanel } from '@/components/ui'
import { useChangelogStore } from '@/stores/changelog'
import ChangelogEntryCard from './ChangelogEntryCard.vue'

const store = useChangelogStore()

const isOpen = computed({
  get: () => store.isOpen,
  set: (value) => { if (!value) store.close() }
})
</script>
